import {useRef} from 'react'

const useExamRoom = () => {
  const audioRef = useRef<any>()
  const handlePlayAudio = (file: any) => {
    audioRef.current?.pause()
    audioRef.current = new Audio(file)
    audioRef.current.play()
  }
  const handlePauseAudio = () => {
    audioRef.current?.pause()
  }

  return {handlePlayAudio, handlePauseAudio}
}

export default useExamRoom
